import {
  request
 } from './Base';

/******************************************************************************
 * SPECIFIC FUNCTION                                                          *
 ******************************************************************************/

/**
 * Perform a sim swap for a service towards the sim number
 *
 * @param serviceId the id of the service
 * @param simNumber the new SIM number
 */
export function simSwap(serviceId, simNumber) {
  return request(`/mvno/sim_swap/${serviceId}/${simNumber}`, "POST");
}

/**
 * Suspend a mvno service
 *
 * @param serviceId the id of the service
 */
export function suspend(serviceId) {
  return request(`/mvno/suspend/${serviceId}`, "POST");
}

/**
 * Reactivate a mvno service
 *
 * @param serviceId the id of the service
 */
export function reactivate(serviceId) {
  return request(`/mvno/reactivate/${serviceId}`, "POST");
}

/**
 * Get data recharge to a mvno service
 */
export function dataRecharge(serviceId) {
  return request(`/mvno/data_recharge/${serviceId}`);
}

/**
 * Add a data recharge to a mvno service
 */
export function addData(serviceId, rechargeId, removeBill = false) {
  return request(`/mvno/add_data/${serviceId}/${rechargeId}${removeBill?"/1":""}`, "POST");
}

/**
 * get the PUK number of a mvno service
 */
export function puk(serviceId) {
  return request(`/mvno/puk/${serviceId}`);
}

/**
 * get the RIO number of a mvno service
 */
export function rio(serviceId) {
  return request(`/mvno/rio/${serviceId}`);
}

/**
 * migrate a mvno service to a new offer
 */
export function migrate() {
  return request('/mvno/migrate/{service_id}');
}

/**
 * Fetch all transatel options to serve in a dropdown form choice
 */
export function registerMVNOService(mvno, params) {
  return request(`/mvno/register/${mvno}`, "PUT", params);
}

/**
 * Fetch all transatel options to serve in a dropdown form choice
 */
export function newMVNOService(mvno, params) {
  return request(`/mvno/new/${mvno}`, "PUT", params);
}

/**
 * Fetch all transatel options to serve in a dropdown form choice
 */
export function newMVNOServiceWithPortability(mvno, params) {
  return request(`/mvno/new_with_portability/${mvno}`, "PUT", params);
}

/**
 * Fetch all transatel options to serve in a dropdown form choice
 */
export function terminate(serviceId) {
  return request(`/mvno/terminate/${serviceId}`, "POST");
}
